import React from 'react'

const Line = ({
  className = '',
  value,
  style
}) => {
  return (
    <div className = {className}>
      <div className="score">{value}</div>
      <div className={`bar ${value>=0 ?'positive':'negative'}`}>
        <span className="fill" style={style}></span>
      </div>
    </div>
  )
}

export default Line



// WEBPACK FOOTER //
// ../app/components/common/charts/Line.jsx